import React from "react";
import DataTableCompo from "../../../components/DataTable/DataTable";
import "./pastGuest.scss";

const PastGuest = () => {
  return (
    <div className="past-guest-containor">
      <DataTableCompo />
    </div>
  );
};

export default PastGuest;
